export default __webpack_public_path__ + "static/twitter-adb15d582cac6a534be8a54afd6c6bd5.png";